import axios from "./axios_client";

/**
 * Users Request
 */
export const logIn = (params) => axios.post("/auth/login", params);

/**
 * Indices Request
 */
export const getIndices = () => axios.get("/indexes");

export const getIndexTile = (params) => axios.post("/tile", params);

/**
 * Static GeoJSON Layers
 */
export const getProjects = () => axios.get("/projects");

export const createProject = (params) => axios.post("/projects", params);

export const validateProjectToken = (params) =>
  axios.post("/projects/tokens/validate", params);

export const createProjectToken = (params) =>
  axios.post("/projects/tokens", params);

export const getAOIGeoJSON = () => axios.get("/aoi");

export const getProjectBounds = () => axios.get("/project/bounds");

/**
 * Owners Request
 */

export const getOwnerBoundaries = (ownerId) =>
  axios.get(`/owner/boundaries/${ownerId}`);

export const getOwnerMeta = (ownerId, areaUnit) =>
  axios.get(`/owner/${ownerId}/meta`, { params: { area_unit: areaUnit } });

/**
 * Fields Requests
 */

export const getFieldAlerts = (fieldId, signal) =>
  axios.get(`/alerts/${fieldId}`, { signal });

export const getFieldStats = (fieldId, signal) =>
  axios.get(`/stats/${fieldId}`, { signal });

export const getFieldAcceptability = (fieldId, signal) =>
  axios.get(`/acceptability/${fieldId}`, { signal });

export const getFieldMeta = (fieldId, areaUnit) =>
  axios.get(`/field/${fieldId}/meta`, { params: { area_unit: areaUnit } });

export const getFields = (params, signal) =>
  axios.get("/fields", { params, signal });

export const fieldsAck = (params) => axios.post("/fields/ack", params);

export const getFieldsLegends = () => axios.get("/fields_legends");

/**
 * Dashboard
 */
export const getOwnerDashboard = (params, signal) =>
  axios.get("/dashboard/owners", { params, signal });

export const getFieldsDashboard = (params, signal) =>
  axios.get("/dashboard/fields", { params, signal });

export const getAlertsDashboard = (params, signal) =>
  axios.get("/dashboard/alerts", { params, signal });

export const getChartsData = (params, signal) =>
  axios.post("/dashboard/charts", params, { signal });

/**
 * Add area
 */
export const createOwner = (params) => axios.post("/owner", params);

export const createField = (params) => axios.post("/field", params);

export const getCropTypes = () => axios.get("/crops");

export const getIrrigationMethods = () => axios.get("/irrigation_methods");

/**
 * Parse uploaded vector file
 */
export const parseVectorFile = (formData) =>
  axios.post("/upload/areas", formData);
export const parseProjectVectorFile = (formData) =>
  axios.post("/upload/project", formData);

/**
 * Parse coordinates list into GeoJSON
 */
export const parseCoordinates = (params) => axios.post("/coordinates", params);

/**
 * Validate area coordinates
 */
export const validateArea = (params) => axios.post("/areas/validate", params);

/**
 * Fix invalid area coordinates
 */
export const fixArea = (params) => axios.post("/areas/fix", params);

/**
 * Update area
 */
export const updateOwner = (params) => axios.put(`/owner`, params);

export const updateField = (params) => axios.put(`/field`, params);

/**
 * Delete area
 */

export const deleteField = (fieldId) => axios.delete(`/field/${fieldId}`);

export const deleteOwner = (ownerId) => axios.delete(`/owner/${ownerId}`);

/**
 * Alerts  Requests
 */
export const reviewedAlerts = (params) => axios.put("/alerts/reviewed", params); // params { alerts_ids (list[str]), reviewed (bool) }

export const validateAlerts = (params) => axios.put("/alerts/validate", params); // params { alerts_ids (list[str]), valid (bool) }

/**
 * Tile limits and checks
 */
export const getTilesLimits = () => axios.get("/tiles/limits");

export const getTileBanStatus = () => axios.get("/tiles/status");

/**
 * Satellite tiles availability check
 */
export const getSatelliteTilesAvailable = () =>
  axios.get("/tiles/satellite/available");

/**
 * Short-lived signed URL template for the satellite basemap (anti-scraping).
 * Must be renewed before `expires_at`.
 */
export const getSatelliteTileTemplate = () =>
  axios.get("/tiles/satellite/template");

export const getPlanetTileTemplate = () => axios.get("/tiles/planet/template");

export const getDefaultMapTileTemplate = () =>
  axios.get("/tiles/defaultmap/template");

export const getAddProjectSatelliteTileTemplate = (token) =>
  axios.get("/tiles/satellite/add-project/template", { params: { token } });

export const getAddProjectPlanetTileTemplate = (token) =>
  axios.get("/tiles/planet/add-project/template", { params: { token } });
